<template>
    <section v-if="temCampanha" class="page pt-3 pb-3">
        <div class="row">
            <div class="col">
                <p class="valor text-uppercase">Apoie as nossas campanhas</p>

                <div v-for="campanha in campanhas" class="row pt-3 pb-3">

                    <div v-if="campanha.pk_id_tipo_banner == 1" class="col">
                        <a :href="campanha.ds_link" target="_blank">
                            <img :src="campanha.url_imagem" :alt="campanha.ds_titulo" class="img-fluid" />
                        </a>
                    </div>

                    <div v-if="campanha.pk_id_tipo_banner == 2" class="col">
                        <div class="card" style="width: 100%">
                            <div class="card-body" v-html="campanha.texto"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                campanhas: []
            }
        },
        computed: {
            temCampanha() {
                return _.size(this.campanhas) > 0
            }
        },
        created() {
            this.$resources.CampanhaVigente.get('').then((response) => {
                this.campanhas = response.data.data
            }).catch((error) => {
                console.dir(error)
            })
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/CampanhaVigente.vue